const BrightcoveLivestream = `
  fragment BrightcoveLivestream on BrightcoveLivestream {
    accountId
    label
    livestreamId
  }
`
export default BrightcoveLivestream
